import { blue05, blue10, blue20, blue20opacity15, blue30 } from '../../../colors/blue';
import { gray40opacity15, gray40opacity40, gray95 } from '../../../colors/gray';
import { red01, red02, red03 } from '../../../colors/red';
export var MuiButton = {
    styleOverrides: {
        root: {
            '&[class*=Mui-focusVisible]': {
                boxShadow: "0 0 0 2px ".concat(blue05),
            },
        },
        containedPrimary: {
            '&:hover': {
                backgroundColor: blue10,
            },
            '&:active': {
                backgroundColor: blue30,
            },
            '&[class*=Mui-disabled]': {
                backgroundColor: blue30,
                color: gray95,
            },
        },
        containedSecondary: {
            '&:hover': {
                backgroundColor: gray40opacity40,
            },
            '&:active': {
                backgroundColor: blue20opacity15,
            },
            '&[class*=Mui-disabled]': {
                backgroundColor: gray40opacity15,
                color: blue20,
            },
        },
        text: {
            color: blue20,
            '&:hover': {
                backgroundColor: gray40opacity40,
            },
            '&:active': {
                backgroundColor: blue20opacity15,
            },
            '&[class*=Mui-disabled]': {
                color: blue20,
            },
        },
    },
    customOverrides: {
        dangerPrimary: {
            backgroundColor: red02,
            color: gray95,
            '&:hover': {
                backgroundColor: red01,
            },
            '&:active': {
                backgroundColor: red03,
            },
            '&[class*=Mui-disabled]': {
                backgroundColor: red02,
                color: gray95,
            },
        },
        dangerSecondary: {
            color: red01,
            '&[class*=Mui-disabled]': {
                color: red01,
            },
        },
        dangerTertiary: {
            color: red01,
            '&[class*=Mui-disabled]': {
                color: red01,
            },
        },
    },
};
